module.exports = __webpack_public_path__ + "static/media/SourceSerifPro-SemiBold.b883eaa1.ttf";